import gql from 'graphql-tag';

import dokkioLabelCapabilitiesFragment from './dokkioLabelCapabilitiesFragment';
import dokkioUserFragment from './dokkioUserFragment';

export const dokkioLabelFragment = gql`
  fragment dokkioLabelFragment on DokkioLabel {
    accountID
    dokkioClass
    id
    name
    nameSingular
    namePlural
    description
    icon
    color
    dokkioTagType
    integrationID
    isMultiValue
    isBadgeDisplayed
    isNavDisplayed
    isPluralTagNames
    defaultAutoApplyConfidenceThreshold
    autoCreateDokkioTagConfidenceThreshold
    filterNotableOrganizationSuggestions
    filterNotablePersonSuggestions
    filterDokkioUserNameSuggestions
    rowCreateMethod
    rowCreatedAt
    creatorDokkioUserID
    creatorDokkioUser {
      ...dokkioUserFragment
    }
    capabilities {
      ...dokkioLabelCapabilitiesFragment
    }
  }
  ${dokkioUserFragment}
  ${dokkioLabelCapabilitiesFragment}
`;
export default dokkioLabelFragment;
